import { Page } from 'corso-admin-ui';
import SearchTable from '~/components/searchTable/SearchTable';

export default function RegistrationsTablePage() {
  return (
    <Page title="Registrations" size="fullWidth">
      <SearchTable />
    </Page>
  );
}
